import { GridColDef } from '@mui/x-data-grid';
import { ColumnPeriodT } from '../helpers/types';

interface UseStatisticGridProps {
  columnPeriods: ColumnPeriodT[];
  stockName?: string;
}

export const useStatisticGrid = ({ columnPeriods, stockName }: UseStatisticGridProps) => {
  const gridColumns: GridColDef[] = [
    { field: 'name', headerName: stockName ? `${stockName} Optic` : 'Name', width: 180 },
    ...columnPeriods.map((col, idx) => ({
      field: `col${idx}`,
      headerName: col.name,
      width: 170,
    }))
  ];

  const buildRow = (name: string, values: string[], id: number) => {
    const row: Record<string, any> = { id, name };
    columnPeriods.forEach((_, idx) => {
      row[`col${idx}`] = values[idx] || '';
    });
    return row;
  };

  const gridStyles = {
    '& .MuiDataGrid-cell': {
      fontSize: 16,
      whiteSpace: 'normal',
      overflow: 'visible',
      textOverflow: 'unset',
      lineHeight: 1.5,
    },
    '& .MuiDataGrid-columnHeader': {
      fontWeight: 600,
      fontSize: 16
    },
  };

  return {
    gridColumns,
    buildRow,
    gridStyles,
  };
};
